import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/schemas';

export const getAskNovoAiState = (state: RootState) => state.app.askNovoAi;

export const getVoteState = createSelector(
  [getAskNovoAiState, (_state: RootState, questionId: number) => questionId],
  (askNovoAiState, questionId) => askNovoAiState.voteState[questionId] || {
    upvoted: false,
    downvoted: false,
    isLoading: false,
    showFeedback: false,
  },
);

export const getHelpOptions = createSelector(
  [getAskNovoAiState],
  (askNovoAiState) => askNovoAiState.helpOptions,
);

export const getRecentQuestions = createSelector(
  [getAskNovoAiState],
  (askNovoAiState) => askNovoAiState.recentQuestions,
);

export const getNovoAiResponse = createSelector(
  [getAskNovoAiState],
  (askNovoAiState) => askNovoAiState.response,
);

export const getAdditionalResources = createSelector(
  [getHelpOptions],
  (helpOptions) => helpOptions?.additionalResources || [],
);

export const getHasAdditionalResourcesChanged = createSelector(
  [getHelpOptions],
  (helpOptions) => helpOptions?.hasAdditionalResourcesChanged || false,
);
